module.exports = __webpack_public_path__ + "static/img/cx05.85c2eb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cx05.png
// module id = GsFI
// module chunks = 0